<template>
  <div class="leaveMsg">
    <div
      class="top"
      :style="`background:url(${
        topbanner.photo && $imgurl + topbanner.photo.url
      })top center/cover no-repeat`"
    >
      <p class="che">在线留言</p>
      <p class="eng">Customer Service</p>
    </div>
    <div class="flex-top-center">
      <div class="con">
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>公司名称</p>
          </div>
          <el-input type="text" v-model="title" />
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>行业类型</p>
          </div>
          <!-- <el-input type="text" v-model="comptype" /> -->
          <el-select v-model="comptype" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>公司地址</p>
          </div>
          <el-input type="text" v-model="compaddr" />
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>联系人姓名</p>
          </div>
          <el-input type="text" v-model="username" />
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>联系电话</p>
          </div>
          <el-input type="text" v-model="telphone" />
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>邮箱</p>
          </div>
          <el-input type="text" v-model="email" />
        </div>
        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>需求描述</p>
          </div>
          <el-input
            type="textarea"
            :maxlength="5000"
            :show-word-limit="true"
            v-model="content"
          />
        </div>

        <div class="form flex-top">
          <div class="label flex-end">
            <span>*</span>
            <p>验证码</p>
          </div>
          <el-input class="code-input" type="text" v-model="code" />
          <div class="code" ref="code"></div>
          <p class="change cursor" @click="changeCode">看不清换一张</p>
        </div>

        <div class="btn flex no-select">
          <div class="confirm cursor" @click="Confirm">提交需求</div>
          <div class="reset cursor" @click="Cancle">重新填写</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: "",
      username: "",
      email: "",
      telphone: "",
      comptype: "",
      compaddr: "",
      content: "",
      code: "",
      topbanner: "",
      verifyCode: null,
      options: [
        {
          value: "证券",
          label: "证券",
        },
        {
          value: "银行",
          label: "银行",
        },
        {
          value: "期货",
          label: "期货",
        },
        {
          value: "产业",
          label: "产业",
        },
        {
          value: "基金",
          label: "基金",
        },
        {
          value: "私募",
          label: "私募",
        },
        {
          value: "保险",
          label: "保险",
        },
        {
          value: "金控集团",
          label: "金控集团",
        },
        {
          value: "信托&AMC",
          label: "信托&AMC",
        },
        {
          value: "基础设施",
          label: "基础设施",
        },
        {
          value: "其他",
          label: "其他",
        },
      ],
      logo_active: require("@/assets/img01/logo-active.png")

    };
  },
  mounted() {
    //获取到配置的头部颜色，听过store监听动态改变
    this.$store.commit("until/SET_COLOR", "#fff");
    this.initCode();
    this.getdata();
    // console.log(this.comptype);
    setTimeout(() => {
      console.log(this.$store.state.until.logo_active);
      if (this.$store.state.until.logo_active) {
        document.getElementById("logo").src = this.logo_active;
        document.querySelector(
          ".header-out .header-inner .find-out .icon"
        ).style.filter = "brightness(0) invert(1)";
        document.querySelector(".header-out .header-inner .lang").style.border =
          "1px solid #fff";
        document.querySelector(".header-out .header-inner .lang").style.color =
          "#fff";
      } else {
        // logoFlag = true
      }
    }, 200);
  },
  methods: {
    initCode() {
      let dom = this.$refs["code"];
      this.verifyCode = new this.$until.GVerify(dom);
    },
    changeCode() {
      this.verifyCode.refresh();
    },
    Confirm() {
      let { title, username, email, telphone, comptype, compaddr, content } =
        this;
      if (
        !title ||
        !username ||
        !email ||
        !telphone ||
        !comptype ||
        !compaddr ||
        !content
      ) {
        this.$message({ message: "请填写完整信息！", type: "warning" });
        return;
      }
      let verify = this.verifyCode.validate(this.code);
      if (!verify) {
        this.$message({ message: "验证码输入错误！", type: "warning" });
        return;
      }

      let data = {
        title,
        username,
        email,
        telphone,
        comptype,
        compaddr,
        content,
      };
      this.$fetch({
        url: "index.php/feedback/sendpost",
        type: "post",
        data: this.$qs.stringify(data),
      }).then((res) => {
        if (res.code == -1) {
          this.$message({ message: res.data.email, type: "warning" });
        }
        if (res.code == 0) {
          this.$message({ message: "提交成功", type: "success" });
          this.Cancle();
        }
      });
    },
    Cancle() {
      this.title = "";
      this.username = "";
      this.email = "";
      this.telphone = "";
      this.comptype = "";
      this.compaddr = "";
      this.content = "";
    },
    getdata() {
      this.$fetch({
        url: "index.php/feedback/initPage",
        type: "get",
      }).then((res) => {
        this.topbanner = res.data.topbanner;
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$store.commit("until/SET_COLOR", "#fff");
      vm.$store.commit("until/SET_LOGO_ACTIVE", true);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("until/SET_COLOR", "#333");
    this.$store.commit("until/SET_LOGO_ACTIVE", false);
    document.getElementById("logo").src = require("@/assets/images/logo.gif");
    document.querySelector(
      ".header-out .header-inner .find-out .icon"
    ).style.filter = "none";
    document.querySelector(".header-out .header-inner .lang").style.border =
      "1px solid #396aff";
    document.querySelector(".header-out .header-inner .lang").style.color =
      "#396aff";
    next();
  }
};
</script>

<style lang="scss" scoped>
.leaveMsg ::v-deep .el-select .el-input__icon {
  line-height: 32px;
}
.top {
  height: 320px;
  // background: url("../assets/images/find-bg.png") center/cover no-repeat;
  padding-top: 153px;
  text-align: center;
  background-size: cover !important;
  width: 100%;
  .che {
    font-size: 36px;
    line-height: 1;
    color: #fff;
  }
  .eng {
    font-size: 16px;
    color: #fff;
    margin-top: 8px;
  }
}
.con {
  padding: 45px 0 72px;
  .form {
    margin-bottom: 24px;
    font-size: 14px;
    color: #333;
    .label {
      width: 100px;
      height: 32px;
      margin-right: 16px;
      span {
        font-size: 18px;
        position: relative;
        top: 5px;
        color: #ff3030;
        margin-right: 5px;
      }
    }
    .el-input,
    .el-select,
    .el-select ::v-deep.el-input__inner,
    .el-input ::v-deep.el-input__inner {
      width: 540px;
      height: 32px;
      font-size: 14px;
    }
    .el-textarea,
    .el-textarea ::v-deep.el-textarea__inner {
      width: 540px;
      height: 200px;
      resize: none;
      padding-bottom: 20px;
      font-size: 14px;
      font-family: auto;
    }

    .code-input,
    .code-input ::v-deep.el-input__inner {
      width: 166px;
      height: 32px;
      font-size: 14px;
    }
    .code {
      width: 104px;
      height: 32px;
      border: 1px solid #d9d9d9;
      margin-left: 8px;
    }
    .change {
      font-size: 14px;
      color: #333;
      line-height: 32px;
      margin-left: 8px;
    }
  }
  .btn {
    margin-top: 40px;
    padding-left: 116px;
    font-size: 14px;
    text-align: center;
    .confirm {
      width: 120px;
      height: 40px;
      line-height: 40px;
      background: #396aff;
      color: #fff;
      margin-right: 16px;
    }
    .reset {
      width: 120px;
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      color: #333;
    }
  }
}
@media (max-width: 1367px) {
  .el-input,
  .el-select,
  .el-select ::v-deep .el-input__inner,
  .el-input ::v-deep .el-input__inner {
    font-size: 14px !important;
  }
  .con ::v-deep .form .el-textarea,
  .con ::v-deep .form .el-textarea .el-textarea__inner {
    font-size: 14px !important;
  }
}
@media (min-width: 750px) {
  .top {
    height: 320px;
    // background: url("../assets/images/find-bg.png") center/cover no-repeat;
    padding-top: 153px;
    background-size: cover !important;
    text-align: center;
    width: 100%;
    .che {
      font-size: 36px;
      line-height: 1;
      color: #fff;
    }
    .eng {
      font-size: 16px;
      color: #fff;
      margin-top: 8px;
    }
  }
  .con {
    padding: 45px 0 72px;
    .form {
      margin-bottom: 24px;
      font-size: 14px;
      color: #333;
      .label {
        width: 100px;
        height: 32px;
        margin-right: 16px;
        span {
          font-size: 18px;
          position: relative;
          top: 5px;
          color: #ff3030;
          margin-right: 5px;
        }
      }
      .el-input,
      .el-select,
      .el-select ::v-deep.el-input__inner,
      .el-input ::v-deep.el-input__inner {
        width: 540px;
        height: 32px;
      }
      .el-textarea,
      .el-textarea ::v-deep.el-textarea__inner {
        width: 540px;
        height: 200px;
        resize: none;
        padding-bottom: 20px;
      }

      .code-input,
      .code-input ::v-deep.el-input__inner {
        width: 166px;
        height: 32px;
      }
      .code {
        width: 104px;
        height: 32px;
        border: 1px solid #d9d9d9;
        margin-left: 8px;
      }
      .change {
        font-size: 14px;
        color: #333;
        line-height: 32px;
        margin-left: 8px;
      }
    }
    .btn {
      margin-top: 40px;
      padding-left: 116px;
      font-size: 14px;
      text-align: center;
      .confirm {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #396aff;
        color: #fff;
        margin-right: 16px;
      }
      .reset {
        width: 120px;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        color: #333;
      }
    }
  }
}
</style>